var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { i18n, utils as dataUtils } from '@easydata/core';
import { domel } from '../utils/dom_elem_builder';
import { Calendar } from './calendar';
var DefaultCalendar = /** @class */ (function (_super) {
    __extends(DefaultCalendar, _super);
    function DefaultCalendar(slot, options) {
        var _this = _super.call(this, slot, options) || this;
        _this.daysOfWeek = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
        _this.months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        _this.calendarBody = null;
        _this.isManualInputChanging = false;
        for (var i = 0; i < _this.daysOfWeek.length; i++) {
            _this.daysOfWeek[i] = i18n.getShortWeekDayName(i + 1);
        }
        for (var i = 0; i < _this.months.length; i++) {
            _this.months[i] = i18n.getLongMonthName(i + 1);
        }
        return _this;
    }
    DefaultCalendar.prototype.setDate = function (date) {
        _super.prototype.setDate.call(this, date);
        this.selectedMonth = this.currentDate.getMonth();
        this.selectedYear = this.currentDate.getFullYear();
        this.rerenderMonth();
    };
    DefaultCalendar.prototype.render = function () {
        var _this = this;
        var header = domel('div', this.slot)
            .addClass(this.cssPrefix + "-header");
        if (this.options.showDateTimeInput) {
            header
                .addChildElement(this.renderManualDateInput());
        }
        else {
            header
                .addChild('span', function (builder) { return _this.headerTextElem = builder.toDOM(); });
        }
        domel(this.slot)
            .addChildElement(this.renderCalendarButtons());
        this.calendarBody = domel('div', this.slot)
            .addClass(this.cssPrefix + "-body")
            .toDOM();
    };
    DefaultCalendar.prototype.getInputDateFormat = function () {
        var settings = i18n.getLocaleSettings();
        return (this.options.timePickerIsUsed)
            ? settings.editDateFormat + " " + settings.editTimeFormat
            : settings.editDateFormat;
    };
    DefaultCalendar.prototype.renderManualDateInput = function () {
        var _this = this;
        var format = this.getInputDateFormat();
        var builder = domel('input')
            .attr('placeholder', format)
            .addClass(this.cssPrefix + "-header-input");
        builder
            .mask(format.replace('yyyy', '9999')
            .replace('MM', '99')
            .replace('dd', '99')
            .replace('HH', '99')
            .replace('mm', '99')
            .replace('ss', '99'))
            .on('input', function (ev) {
            builder.removeClass('error');
            try {
                _this.isManualInputChanging = true;
                var newDate = dataUtils.strToDateTime(_this.manualInputElem.value, format);
                _this.currentDate = newDate;
                _this.jump(_this.currentDate.getFullYear(), _this.currentDate.getMonth());
                _this.dateChanged(false);
            }
            catch (e) {
                builder.addClass('error');
            }
            finally {
                _this.isManualInputChanging = false;
            }
        })
            .on('keydown', function (ev) {
            if (ev.keyCode === 13) {
                ev.preventDefault();
                ev.stopPropagation();
                if (_this.manualInputElem.className.indexOf('error') < 0
                    && !_this.isManualInputChanging)
                    _this.dateChanged(true);
            }
        })
            .on('focus', function () {
            setTimeout(function () {
                _this.manualInputElem.selectionStart = 0;
                _this.manualInputElem.selectionEnd = 0;
            }, 50);
        });
        this.manualInputElem = builder.toDOM();
        return this.manualInputElem;
    };
    DefaultCalendar.prototype.updateDisplayedDateValue = function () {
        if (this.manualInputElem) {
            if (!this.isManualInputChanging) {
                var format = this.getInputDateFormat();
                this.manualInputElem.value = dataUtils.dateTimeToStr(this.currentDate, format);
                this.manualInputElem.focus();
            }
        }
        else if (this.headerTextElem) {
            var locale = i18n.getCurrentLocale();
            this.headerTextElem.innerText = this.currentDate.toLocaleString(locale == 'en' ? undefined : locale, {
                year: 'numeric',
                month: 'long',
                day: 'numeric',
            });
        }
    };
    DefaultCalendar.prototype.renderCalendarButtons = function () {
        var _this = this;
        var builder = domel('nav')
            .addClass(this.cssPrefix + "-nav")
            .addChild('div', function (builder) { return builder
            .addClass(_this.cssPrefix + "-nav-prev")
            .on('click', function () {
            _this.prev();
        })
            .addChild('span', function (builder) { return builder.html('&lsaquo;'); }); })
            .addChild('div', function (builder) { return builder
            .addClass(_this.cssPrefix + "-nav-selectors")
            .addChild('div', function (builder) { return builder
            .addClass(_this.cssPrefix + "-nav-month")
            .addChild('select', function (builder) {
            builder
                .on('change', function () {
                _this.jump(_this.selectedYear, parseInt(_this.selectMonthElem.value));
            });
            var _loop_1 = function (i) {
                builder.addChild('option', function (builder) { return builder
                    .attr('value', i.toString())
                    .text(_this.months[i]); });
            };
            for (var i = 0; i < _this.months.length; i++) {
                _loop_1(i);
            }
            _this.selectMonthElem = builder.toDOM();
        }); })
            .addChild('div', function (builder) { return builder
            .addClass(_this.cssPrefix + "-nav-year")
            .addChild('select', function (builder) { return _this.selectYearElem = builder
            .on('change', function () {
            _this.jump(parseInt(_this.selectYearElem.value), _this.selectedMonth);
        })
            .toDOM(); }); }); })
            .addChild('div', function (builder) { return builder
            .addClass(_this.cssPrefix + "-nav-next")
            .on('click', function () {
            _this.next();
        })
            .addChild('span', function (builder) { return builder.html('&rsaquo;'); }); });
        return builder.toDOM();
    };
    DefaultCalendar.prototype.prev = function () {
        this.selectedYear = (this.selectedMonth === 0) ? this.selectedYear - 1 : this.selectedYear;
        this.selectedMonth = (this.selectedMonth === 0) ? 11 : this.selectedMonth - 1;
        this.rerenderMonth();
    };
    DefaultCalendar.prototype.next = function () {
        this.selectedYear = (this.selectedMonth === 11) ? this.selectedYear + 1 : this.selectedYear;
        this.selectedMonth = (this.selectedMonth + 1) % 12;
        this.rerenderMonth();
    };
    DefaultCalendar.prototype.rerenderSelectYear = function () {
        var match = /c-(\d*):c\+(\d*)/g.exec(this.options.yearRange);
        var minusYear = 0;
        var plusYear = 1;
        if (match !== null) {
            minusYear = parseInt(match[1]);
            plusYear = parseInt(match[2]);
        }
        this.selectYearElem.innerHTML = '';
        for (var i = 0; i <= minusYear + plusYear; i++) {
            var op = document.createElement("option");
            var year = this.selectedYear - minusYear + i;
            op.value = year.toString();
            op.innerText = year.toString();
            this.selectYearElem.appendChild(op);
        }
    };
    DefaultCalendar.prototype.jump = function (year, month) {
        this.selectedYear = year;
        this.selectedMonth = month;
        this.rerenderMonth();
    };
    DefaultCalendar.prototype.rerenderMonth = function () {
        var _this = this;
        //header text
        this.updateDisplayedDateValue();
        this.rerenderSelectYear();
        var firstDay = (new Date(this.selectedYear, this.selectedMonth)).getDay();
        var daysInMonth = new Date(this.selectedYear, this.selectedMonth + 1, 0).getDate();
        this.calendarBody.innerHTML = "";
        this.selectYearElem.value = this.selectedYear.toString();
        this.selectMonthElem.value = this.selectedMonth.toString();
        this.daysOfWeek.forEach(function (day, idx) {
            domel('div', _this.calendarBody)
                .addClass(_this.cssPrefix + "-weekday")
                .addClass(idx == 0 || idx == 6 ? _this.cssPrefix + "-weekend" : '')
                .text(day);
        });
        // Add empty cells before first day
        for (var i = 0; i < firstDay; i++) {
            domel('div', this.calendarBody)
                .addClass(this.cssPrefix + "-day-empty");
        }
        // Add all month days
        var today = new Date();
        for (var day = 1; day <= daysInMonth; day++) {
            var builder = domel('div', this.calendarBody)
                .addClass(this.cssPrefix + "-day")
                .attr('data-date', day.toString())
                .text(day.toString())
                .on('click', function (e) {
                _this.currentDate.setFullYear(_this.selectedYear);
                _this.currentDate.setMonth(_this.selectedMonth);
                _this.currentDate.setDate(parseInt(e.target.getAttribute('data-date')));
                _this.dateChanged(_this.options.oneClickDateSelection);
            });
            if (day === today.getDate() && this.selectedYear === today.getFullYear() && this.selectedMonth === today.getMonth()) {
                builder.addClass(this.cssPrefix + "-day-current");
            }
            if (day === this.currentDate.getDate() && this.selectedYear === this.currentDate.getFullYear() && this.selectedMonth === this.currentDate.getMonth()) {
                builder.addClass(this.cssPrefix + "-day-selected");
            }
            var dayOfWeek = (firstDay + day - 1) % 7;
            if (dayOfWeek == 0 || dayOfWeek == 6) {
                builder.addClass(this.cssPrefix + "-weekend");
            }
        }
        // Add empty cells after last day
        var cellsDrawnInLastRow = (firstDay + daysInMonth) % 7;
        var cellsToDraw = cellsDrawnInLastRow == 0 ? 0 : 7 - cellsDrawnInLastRow;
        for (var i = 0; i < cellsToDraw; i++) {
            domel('div', this.calendarBody)
                .addClass(this.cssPrefix + "-day-empty");
        }
    };
    DefaultCalendar.prototype.dateChanged = function (apply) {
        _super.prototype.dateChanged.call(this, apply);
        this.rerenderMonth();
    };
    return DefaultCalendar;
}(Calendar));
export { DefaultCalendar };
//# sourceMappingURL=default_calendar.js.map